import { render, staticRenderFns } from "./CertificatesView.vue?vue&type=template&id=71cdb40b&scoped=true"
import script from "./CertificatesView.vue?vue&type=script&lang=js"
export * from "./CertificatesView.vue?vue&type=script&lang=js"
import style0 from "./CertificatesView.vue?vue&type=style&index=0&id=71cdb40b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cdb40b",
  null
  
)

export default component.exports